/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_ACES_VERIFICATIONS,
  GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID,
  POST_ACES_VERIFICATIONS_LINK_FILE,
  DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID,
  POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK,
  SET_DOCUMENTS_SUBMITTED,
  SET_FORM,
} from './actionTypes';

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesVerificationsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_VERIFICATIONS);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesVerificationsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_VERIFICATIONS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesVerificationsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_VERIFICATIONS);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getAcesVerificationsByVerificationIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetAcesVerificationsByVerificationIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getAcesVerificationsByVerificationIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_ACES_VERIFICATIONS_BY_VERIFICATION_ID);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesVerificationsLinkFileReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_VERIFICATIONS_LINK_FILE);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesVerificationsLinkFileReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_VERIFICATIONS_LINK_FILE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesVerificationsLinkFileErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_VERIFICATIONS_LINK_FILE);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const deleteAcesVerificationsFileLinksByLinkIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingDeleteAcesVerificationsFileLinksByLinkIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(
    state,
    action,
    DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID
  );

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const deleteAcesVerificationsFileLinksByLinkIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, DELETE_ACES_VERIFICATIONS_FILE_LINKS_BY_LINK_ID);

/**
 * Updates the details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesVerificationsCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the indicator of creation of details in the 'Verifications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesVerificationsCreateCaseworkerTaskReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesVerificationsCreateCaseworkerTaskErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACES_VERIFICATIONS_CREATE_CASEWORKER_TASK);

/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const setDocumentsSubmittedReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, { successAction: SET_DOCUMENTS_SUBMITTED });

/**
 * Updates the store with the new data.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const setFormReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, { successAction: SET_FORM });

const reducers = combineReducers({
  fetchAcesVerifications: fetchAcesVerificationsReducer,

  isFetchingFetchAcesVerifications: isFetchingFetchAcesVerificationsReducer,
  fetchAcesVerificationsError: fetchAcesVerificationsErrorReducer,

  getAcesVerificationsByVerificationId: getAcesVerificationsByVerificationIdReducer,

  isFetchingGetAcesVerificationsByVerificationId:
    isFetchingGetAcesVerificationsByVerificationIdReducer,
  getAcesVerificationsByVerificationIdError: getAcesVerificationsByVerificationIdErrorReducer,

  postAcesVerificationsLinkFile: postAcesVerificationsLinkFileReducer,

  isFetchingPostAcesVerificationsLinkFile: isFetchingPostAcesVerificationsLinkFileReducer,
  postAcesVerificationsLinkFileError: postAcesVerificationsLinkFileErrorReducer,

  deleteAcesVerificationsFileLinksByLinkId: deleteAcesVerificationsFileLinksByLinkIdReducer,

  isFetchingDeleteAcesVerificationsFileLinksByLinkId:
    isFetchingDeleteAcesVerificationsFileLinksByLinkIdReducer,
  deleteAcesVerificationsFileLinksByLinkIdError:
    deleteAcesVerificationsFileLinksByLinkIdErrorReducer,

  postAcesVerificationsCreateCaseworkerTask: postAcesVerificationsCreateCaseworkerTaskReducer,

  isFetchingPostAcesVerificationsCreateCaseworkerTask:
    isFetchingPostAcesVerificationsCreateCaseworkerTaskReducer,
  postAcesVerificationsCreateCaseworkerTaskError:
    postAcesVerificationsCreateCaseworkerTaskErrorReducer,

  documentsSubmitted: setDocumentsSubmittedReducer,

  form: setFormReducer,
});

export default { reducers };
